import { isEmpty } from '../utils/collection.utils';
import { addDays } from '../utils/date.utils';
import { max, min } from '../utils/number.utils';
import { Pause } from './pause';

export class ValidationDetail {
  public open: boolean;

  constructor(
    public hash?: string,
    public startTime?: number,
    public endTime?: number,
    public realTime?: number,
    public maxRealTime?: number,
    public alarm?: boolean,
    public subactivityHash?: string,
    public subactivityName?: string,
    public programHash?: string,
    public programReference?: string,
    public programTime?: number,
    public programTool?: string,
    public printHash?: string,
    public printReference?: string,
    public manufacturingOrderHash?: string,
    public manufacturingOrderCode?: string,
    public materialHash?: string,
    public materialCode?: string,
    public materialFileName?: string,
    public partHash?: string,
    public partName?: string,
    public alarms?: string[],
    public stop?: boolean,
    public alarmStopped?: boolean,
    public maintenance?: boolean,
    public preparation?: boolean,
    public editable?: boolean,
    public execution?: boolean,
    public minRealTime?: number,
    public pauses?: Pause[]
  ) {}

  get materialPart() {
    return (this.materialFileName && this.partName) ? `${this.materialFileName} (${this.partName})` : this.materialFileName;
  }

  get isCompleted() {
    return this.programHash !== null && this.printHash !== null;
  }

  getDateRealTime(from: number) {
    const to = addDays(1, from);
    const start = max(this.startTime, from);
    const end = min(this.endTime, to);

    return end - start;
  }

  get hasAlarms() {
    return (this.isShownAsAlarm || !isEmpty(this.alarms));
  }

  get isShownAsAlarm() {
    return (this.alarm || this.alarmStopped);
  }

  get hasPauses() {
    return !isEmpty(this.pauses);
  }

  toggleOpen() {
    this.open = !this.open;
  }

  clone() {
    return new ValidationDetail(
      this.hash,
      this.startTime,
      this.endTime,
      this.realTime,
      this.maxRealTime,
      this.alarm,
      this.subactivityHash,
      this.subactivityName,
      this.programHash,
      this.programReference,
      this.programTime,
      this.programTool,
      this.printHash,
      this.printReference,
      this.manufacturingOrderHash,
      this.manufacturingOrderCode,
      this.materialHash,
      this.materialCode,
      this.materialFileName,
      this.partHash,
      this.partName,
      this.alarms,
      this.stop,
      this.alarmStopped,
      this.maintenance,
      this.preparation,
      this.editable,
      this.execution,
      this.minRealTime
    );
  }
}



// WEBPACK FOOTER //
// /var/www/borneo/prod/borneo_app/src/app/core/models/validation-detail.ts